// HEADER
export const headerHeight = '112px';
export const headerHeightDesktop = '80px';
// NAV
export const navHeight = '56px';
export const navWidth = '96px';
// BREAKPOINTS
export const bpXSmall = '320px';
export const bpSmall = '576px';
export const bpMedium = '768px';
export const bpLarge = '992px';
export const bpXLarge = '1200px';
export const bpXXLarge = '1400px';

export const viewports = {
  bpExtraSmall: {
    name: 'X Small',
    styles: {
      width: bpXSmall,
      height: '540px',
    },
  },
  bpSmall: {
    name: 'Small',
    styles: {
      width: bpSmall,
      height: '768px',
    },
  },
  bpMedium: {
    name: 'Medium',
    styles: {
      width: bpMedium,
      height: '768px',
    },
  },
  bpLarge: {
    name: 'Large',
    styles: {
      width: bpLarge,
      height: '768px',
    },
  },
  bpXLarge: {
    name: 'X Large',
    styles: {
      width: bpXLarge,
      height: '768px',
    },
  },
  bpXXLarge: {
    name: 'XX Large',
    styles: {
      width: bpXXLarge,
      height: '768px',
    },
  },
};

export const breakpointFrom = (point: string) =>
  `screen and (min-width: ${point})`;
export const breakpointTo = (point: string) =>
  `screen and (max-width: ${point})`;
export const breakpointBetween = (from: string, to: string) =>
  `screen and (min-width: ${from}), screen and (max-width: ${to})`;
